
import { Component, Vue } from 'vue-property-decorator'
import { ADINFO_ITEM, PROD_LIST_ITEM } from '@/api/xiecheng-api'
import { adInfo, getTicketList, getHomeView } from '@/api/xiecheng'
import { formatDate } from '@/utils/tool'

@Component({
  name: 'Ticket'
})
export default class Ticket extends Vue {
  private defaultImg = 'http://qnimg.zowoyoo.com/img/84826/1680261061590.png';
  private loading = true; // 设置为true是为了先展示骨架屏
  private bannerList = [] as Array<ADINFO_ITEM>; // 轮播图
  private keyword = ''; // 搜索关键字
  private tagList = [] as Array<PROD_LIST_ITEM>
  private prodList = [] as Array<PROD_LIST_ITEM>; // 产品列表
  private startDay = formatDate(+new Date(), 'Y-M-D'); // 开始日期
  private endDay = formatDate(+new Date() + 24 * 60 * 60 * 1000, 'Y-M-D'); // 结束日期

  // 轮播广告位
  gerAdInfo () {
    adInfo()
      .then(res => {
        this.loading = false
        if ((res && res.viewInfoVoList) || res.success) {
          this.bannerList = res.viewInfoVoList || []
        } else {
          console.error(res.msg)
          this.$message.error(res.msg)
        }
      })
      .catch(err => {
        console.log(err)
      })
  }

  handleViewTag () {
    getHomeView({
      pageNo: 1,
      pageSize: 8
    }).then(res => {
      if (res.success) {
        this.tagList = res.ticketList
      }
    })
  }

  // 产品列表
  handleList () {
    const params = {
      edate: this.endDay,
      pageNo: '1',
      pageSize: '10',
      sdate: this.startDay
    }
    getTicketList(params)
      .then(res => {
        if ((res && res.ticketList) || res.success) {
          this.prodList = res.ticketList || []
        } else {
          console.error(res.msg)
          this.$message.error(res.msg)
        }
      })
      .catch(err => {
        console.log(err)
      })
  }

  // 跳转到门票详情
  private goToDetail (id) {
    const queryParams = new URLSearchParams({
      infoId: id
    })
    const url = `/ticketDetail?${queryParams.toString()}`
    this.$router.push(url)
  }

  // 跳转到门票详情
  private goToList () {
    let url = '/ticketList'
    if (this.keyword) {
      url = url + `?key=${this.keyword}`
    }
    this.$router.push(url)
  }

  mounted () {
    // this.gerAdInfo()
    this.handleList()
    this.handleViewTag()
  }
}
